<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.advTitle"
            placeholder="广告标题"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.type"
                  placeholder="分类"
                  width="50"
          >
            <el-option
                    v-for="item in ztOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="标题"
      >
        <template slot-scope="scope">
          {{scope.row.advTitle}}
        </template>
      </el-table-column>
      <el-table-column
        label="图片"
        :show-overflow-tooltip="true"
        width="450"
      >
        <template slot-scope="scope">

          <div v-if="scope.row.advImg!=null && scope.row.advImg!=''">
  <span v-for="(item,index) in scope.row.advImg.split(',')">
          <div v-if="scope.row.media_type=='2'">
            <video
                    v-bind:src="getImgUrl2(item)"
                    class="avatar video-avatar"
                    controls="controls"  style="width: 200px;height: 100px; "></video>
          </div>
          <div v-else-if="scope.row.media_type=='3'">
            <audio controls ref="audio"  class="aud">

              <source :src="getImgUrl2(item)" />

            </audio>
            <img :src= "getImgUrl2(item)" style="width: 200px;height: 100px; "/>
          </div>
          <div v-else>
            <img :src= "getImgUrl2(item)" style="width: 200px;height: 100px; "/>
          </div>
  </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="广告链接"
              width="200"
      >
        <template slot-scope="scope">
          {{scope.row.advUrl}}
        </template>
      </el-table-column>
      <el-table-column
              label="广告位编号"
      >
        <template slot-scope="scope">
          {{scope.row.advPos}}
        </template>
      </el-table-column>
      <el-table-column
        label="广告类型"
        prop="sort_id"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type=='1'">
            首页面
          </div>
          <div v-else-if="scope.row.type=='2'">
            黄历
          </div>
          <div v-else-if="scope.row.type=='3'">
            个人中心
          </div>
          <div v-else-if="scope.row.type=='4'">
            八字排盘
          </div>
            <div v-else-if="scope.row.type=='5'">
                视频列表
            </div>

        </template>
      </el-table-column>
      <el-table-column
              label="是否关联商品"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.inter_id==''">
            未关联
          </div>
          <div v-else>
            已关联
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="排序"
      >
        <template slot-scope="scope">
          {{scope.row.advSort}}
        </template>
      </el-table-column>
      <el-table-column
              label="状态"
              prop="sort_id"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.state=='0'">
            正常
          </div>
          <div v-else-if="scope.row.state=='1'">
           禁用
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="openEditForm(scope.row)"
          >编辑</el-button>
            <el-button
                    v-if="scope.row.state=='0'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,1)"
            >禁用</el-button>
            <el-button
                    v-if="scope.row.state=='1'"
                    type="primary"
                    plain
                    size="mini"
                    @click="update(scope.row.id,0)"
            >恢复</el-button>

          <el-button
            type="primary"
            plain
            size="mini"
            @click="del(scope.row.id)"
          >删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />



  </d2-container>
</template>
<script>
import * as oneclassService from "@/api/sys/oneclass";
import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
import util from '@/libs/util.js'
export default {
  name: "SmallposterPage",
  components: { editForm },
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
        typeOptions: [
            {
                value: "0",
                label: "正常"
            },
            {
                value: "1",
                label: "禁用"
            }
        ],
      ztOptions: [

        {
          value: "1",
          label: "首页面"
        },
        {
          value: "2",
          label: "黄历"
        },
        {
          value: "3",
          label: "个人中心"
        },
        {
          value: "4",
          label: "八字排盘"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        clicksFormVisible:false,
        exposureFormVisible: false,
      editFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          xt_id: util.cookies.get('xt_id'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getAdvertSelPagedList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
      getImgUrl(row){
          return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row.advImg;
      },
    getImgUrl2(row){
      return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row;
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
      openExposureForm(oneclass) {
          this.oneclass = oneclass;
          this.exposureFormVisible = true;
      },
      openClicksForm(oneclass) {
          this.oneclass = oneclass;
          this.clicksFormVisible = true;
      },

    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService
          .batchAdvertSel({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
      update(id,type){
          let msg = type == 1 ? "禁用" : "恢复";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              agentService.updateAdvertSel({id:id,state:type}).then(() => {
                  this.getTableData();
              });
          });
      },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delAdvertSel({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
